import React from 'react'
import { FormattedMessage } from 'react-intl'
import { DASHBOARD_ACCENT_COLOR, DEFAULT_ACCENT, LIBRARY_ACCENT, SOLUTION_ACCENT, REPORTS_ACCENT_COLOR } from 'utils/constants'
import appMessages from 'utils/messages'
import { routeMapping } from 'routes'

export const settingsMainLinks = {
  defaultOpen: [0],
  items: [
    {
      id: 'main',
      color: 'accent0',
      hasPermissions: true,
      actions: [
        {
          id: 'overview',
          to: '/',
          color: 'accent0',
          label: 'Back',
          icon: 'back',
          hasPermissions: true
        },
      ]
    }
  ]
}

export const headerLinks = [
  {
    id: 'workspaceSettings',
    type: 'button',
    to: routeMapping.WORKSPACE.path,
    label: <FormattedMessage {...appMessages.workspaceSettings} />
  },
  {
    id: 'members',
    type: 'button',
    to: routeMapping.SETTINGS_USER.path,
    label: <FormattedMessage {...appMessages.members} />
  }
]

export const trainLinks = [
  {
    id: 'videos',
    to: routeMapping.LIBRARY_VIDEOS.path,
    color: LIBRARY_ACCENT,
    label: 'Data Collection',
    icon: 'dataCollection',
  },
  {
    id: 'dataset',
    to: routeMapping.LIBRARY_DATASETS.path,
    color: LIBRARY_ACCENT,
    label: 'Datasets',
    icon: 'datasets',
  },
  {
    id: 'imageAnnotation',
    to: routeMapping.ANNOTATION_TAKS.path,
    color: LIBRARY_ACCENT,
    label: 'Image Annotation',
    icon: 'imageAnnotation',
  },
  {
    id: 'modelTraining',
    to: routeMapping.EXPERIMENTS.path,
    color: LIBRARY_ACCENT,
    label: 'Model Training',
    icon: 'modelTraining',
  },
  {
    id: 'models',
    to: routeMapping.LIBRARY_MODELS.path,
    color: LIBRARY_ACCENT,
    label: 'AI Models',
    icon: 'aiModels',
  },
]

export const developLinks = [
  {
    id: 'modules',
    icon: 'buildingBlocks',
    color: LIBRARY_ACCENT,
    to: routeMapping.LIBRARY_MODULES.path,
    label: 'Building Blocks',
  },
  {
    id: 'application-edit',
    icon: 'editor',
    color: LIBRARY_ACCENT,
    to: routeMapping.APPLICATIONS_VISUAL_EDITOR_PAGE.path,
    label: 'Visual Editor',
  },
  {
    id: 'applications',
    icon: 'applications',
    color: LIBRARY_ACCENT,
    to: routeMapping.LIBRARY_APPLICATIONS.path,
    label: 'Applications',
  },
]

export const deployLinks = [
  {
    id: 'devices-enrollment',
    icon: 'deviceEnrollment',
    deviceEnrollment: true,
    color: DEFAULT_ACCENT,
    to: routeMapping.PENDING_DEVICE_TYPE_LIST.path,
    label: 'Device Enrollment',
  },
  {
    id: 'device-management',
    icon: 'deviceManagement',
    color: DEFAULT_ACCENT,
    to: routeMapping.DEPLOYMENT_DEVICES.path,
    label: 'Device Management',
  },
  {
    id: 'profiles',
    icon: 'deploymentCenter',
    color: DEFAULT_ACCENT,
    to: routeMapping.DEPLOYMENT_PROFILES.path,
    label: 'Deployment Center',
  },
  {
    id: 'device-configuration',
    icon: 'configurations',
    color: DEFAULT_ACCENT,
    to: routeMapping.DEPLOYMENT_DEVICES_MANAGER.path,
    label: 'Configurations',
  },
]

export const operateLinks = [
  {
    id: 'dashboards',
    icon: 'monitoring',
    color: DASHBOARD_ACCENT_COLOR,
    to: routeMapping.DASHBOARDS.path,
    label: 'Dashboards',
  },
  {
    id: 'reports',
    icon: 'reports',
    color: REPORTS_ACCENT_COLOR,
    to: routeMapping.REPORTS.path,
    label: 'Reports',
  },
  {
    id: 'incidents',
    icon: 'incidents',
    color: DEFAULT_ACCENT,
    to: routeMapping.INCIDENT.path,
    label: 'Incident Center',
  },
]

export const profileLinks = [
  {
    id: 'myProfile',
    icon: 'profileCircle',
    to: routeMapping.PROFILE.path,
    color: SOLUTION_ACCENT,
    label: 'My Profile',
  },
  {
    icon: 'workspace',
    id: 'myWorkspaces',
    to: routeMapping.MANAGE_WORKSPACE.path,
    color: SOLUTION_ACCENT,
    label: 'My Workspaces',
  },
]

export const securityLinks = [
  {
    icon: 'usersOutline',
    id: 'users',
    color: SOLUTION_ACCENT,
    to: routeMapping.SETTINGS_USER.path,
    label: 'User Management',
  },
  {
    icon: 'accessKey',
    id: 'role',
    color: SOLUTION_ACCENT,
    to: routeMapping.SETTINGS_ROLE.path,
    label: 'Roles and Access',
  },
  {
    icon: 'locationOutline',
    id: 'locations',
    color: SOLUTION_ACCENT,
    to: routeMapping.LOCATION_LIST.path,
    label: 'Location Manager',
  },
  {
    icon: 'authentication',
    id: 'authentication',
    color: SOLUTION_ACCENT,
    to: routeMapping.AUTHENTICATION.path,
    label: 'Authentication',
  },
  {
    icon: 'terminalOutline',
    id: 'terminalAccess',
    color: SOLUTION_ACCENT,
    to: `${routeMapping.SETTINGS.path}/terminal`,
    label: 'Terminal Access',
  },
  {
    icon: 'viewer',
    id: 'videoViewer',
    color: SOLUTION_ACCENT,
    to: `${routeMapping.SETTINGS.path}/video-access`,
    label: 'Video Viewer Access',
  },
  {
    icon: 'auditLog',
    id: 'audit',
    color: SOLUTION_ACCENT,
    to: `${routeMapping.SETTINGS.path}/audit-log`,
    label: 'Audit Log',
  },
]

export const accountLinks = [
  {
    icon: 'settings',
    id: 'myWorkspaceSettings',
    color: REPORTS_ACCENT_COLOR,
    to: routeMapping.WORKSPACE.path,
    label: 'Workspace Settings',
  },
  {
    icon: 'aiContent',
    id: 'aiContentCenter',
    color: REPORTS_ACCENT_COLOR,
    to: routeMapping.AI_CONTENT_CENTER.path,
    label: 'AI Content Center',
  },
  {
    icon: 'alertSettings',
    id: 'notificationDefaults',
    color: SOLUTION_ACCENT,
    to: routeMapping.NOTIFICATION_DEFAULTS.path,
    label: 'Notification Defaults',
  },
]

export const moreLinks = [
  {
    icon: 'partner',
    id: 'partner',
    color: DEFAULT_ACCENT,
    to: routeMapping.PARTNER.path,
    label: 'Partner Portal',
  },
  {
    icon: 'marketplaceOutline',
    id: 'marketplace',
    color: DASHBOARD_ACCENT_COLOR,
    to: routeMapping.MARKETPLACE.path,
    label: 'Marketplace',
  },
]